import { initReactI18next } from 'react-i18next';

import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

/*
 * i18next initialization
 */

const i18nInit = (callback: (err: any) => void) => {
    i18n
        .use(Backend)
        .use(LanguageDetector)
        .use(initReactI18next)
        .init({
            backend: {
                // @ts-ignore
                loadPath: process.env.REACT_APP_API_HOST + (window.pfcCo2Tool !== undefined ? '/cors' : '') + '/locales/{{lng}}',
            },
            detection: {
                order: ['localStorage', 'navigator'],
                lookupLocalStorage: 'language',
            },
            fallbackLng: 'it-IT',
            debug: process.env.NODE_ENV === 'development',
            interpolation: {
                escapeValue: false,
            },
            react: {
                useSuspense: true
            }
         }, (err) => callback(err));
};

export default i18nInit;

export { i18n };
